import React, { CSSProperties, useState } from 'react';
import Select from 'react-select'
import { useFormikContext, getIn } from 'formik';
import { Button, Container, Row } from 'reactstrap';
import { useEffect } from 'react';

/**
 * Inform Typescript of whether an 'options' object is an array of strings, or value-label pairs.
 * @param options The options object
 */
function HaveLabels(options: { value: string, label: string }[] | string[]): options is string[] {
    return typeof options[0] == "string";
}

type Props = {
    hideAllButton?: unknown;
    id: string;
    isMulti?: boolean;
    options?: { value: string, label: string }[] | string[];
    style?: CSSProperties;
    onChange?: (arr: unknown[]) => (void | Promise<void>);
    invalid?: unknown;
} & { [p: string]: unknown };

const Selector = ({ hideAllButton, id, isMulti, options, style, onChange, invalid, ...rest }: Props) => {
    const { touched, errors } = useFormikContext();
    const [currentOptions, setCurrentOptions] = useState([] as { value: string, label: string }[]);
    const isInvalid = invalid || (id && getIn(errors, id) && getIn(touched, id));
    const nustyle = isInvalid ? { borderColor: 'red' } : null;
    const selectAll = () => {
        if (currentOptions instanceof Array && onChange) onChange([...currentOptions]);
    }
    useEffect(() => {
        if (options instanceof Array) {
            if (HaveLabels(options)) {
                setCurrentOptions(options.map(option => ({ value: option, label: option })));
            }
            else { setCurrentOptions(options); }
        }
    }, [options]);
    return <Container>
        <Row style={{ flexDirection: 'row-reverse' }}>
            {onChange && isMulti && !hideAllButton && <Button className="link" style={{ marginBottom: '10px' }} onClick={selectAll}>Select All</Button>}
        </Row><Row>
            <Select onChange={onChange} id={id} isMulti={isMulti} options={currentOptions} styles={{
                container: base => ({
                    ...base,
                    flex: 1,

                }),
                control: provided => ({ ...provided, ...nustyle }),
                // Fixes the overlapping problem of the component
                menu: provided => ({ ...provided, zIndex: 9999 })
                ,
            }} {...rest} />
        </Row>
    </Container>
}
export default Selector